import { render } from "./addFavDailog.vue?vue&type=template&id=62d067dc&scoped=true"
import script from "./addFavDailog.vue?vue&type=script&lang=js"
export * from "./addFavDailog.vue?vue&type=script&lang=js"

import "./addFavDailog.vue?vue&type=style&index=0&id=62d067dc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62d067dc"]])

export default __exports__